import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ContactPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
